import { DeliveryOrderBatchCreatePage } from "@/features/delivery-order-batch/pages/DeliveryOrderBatchCreatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/delivery-order-batch/create")({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({ permissions: ["delivery_order.batch_generate"] })
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: DeliveryOrderBatchCreatePage,
});
